import React from 'react'

const VasthuProfessionalReview = () => {
  return (
    <div>Vasthu Consultant Review</div>
  )
}

export default VasthuProfessionalReview